import templateUrl from 'emun.salesrep/salesrep-shipments-goals-ly-chart.htm'
class SalesRepShipmentsGoalsLYChartController {
    constructor($window, $rootScope, retailerPrompt, createAutoQuery) { 
        let $ctrl = this;
		if (!$ctrl.mode) { $ctrl.mode = 'list'; }
        $ctrl.chartLoaded = false;
        this.quarterShipments = {
            total: 0,
            count: 0,
			percent: 0,
			trend: 'neutral'
        };
        this.ytdShipments = {
            total: 0,
            count: 0,
			percent: 0,
			trend: 'neutral'
        };
        this.monthShipments = {
            total: 0,
            count: 0,
			percent: 0,
			trend: 'neutral'
        };
        this.quarterShipmentsLY = {
            total: 0,
            count: 0
        };
        this.ytdShipmentsLY = {
            total: 0,
            count: 0
        };
        this.monthShipmentsLY = {
            total: 0,
            count: 0
        };

        this.chartOptions = {
            maintainAspectRatio: false,
            legend: { 
                display: true,
                labels: {
                    boxWidth: 5,
                    fontSize: 10
                }
            },
            elements: {
                rectangle: {
                    borderWidth: 1
                }
            },
            scales: {
                yAxes: [{
                    display: true,
                    ticks: {
                        callback: function(value, index, values) {
                            return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        },
                        fontSize: 11
                    }
                }]
            },
            tooltips: {
                enabled: true,
                callbacks: {
                    label: function(tooltipItem, data) {
                        var label = data.datasets[tooltipItem.datasetIndex].label ;
                        var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                        return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        //                        return label + ': ' + $filter('currency')(datasetLabel);
                    }
                }
            },
        }

  //      var context = this.context || 'rep';

		//var filter = "SalesRepID";
		//var groupBy = "SalesRepID";
		//if (context == 'manager') {
		//	filter = "ManagerId";
		//} else if (context == 'vendor') {
		//	filter = "VendorId";
		//	groupBy = "VendorId";
		//}

		var context = $ctrl.context || 'rep';
		var repFilter = "";
		var groupBy = "SalesRepID";
		if (context != 'executive') {
			var filterType = "SalesRepID";
			if (context == 'manager') {
				filterType = 'ManagerId';
			} else if (context == 'vendor') {
				filterType = 'VendorId';
				groupBy = "VendorId";
			}
			repFilter = "&" + filterType + "=" + $ctrl.rep.id;
		}


        this.shipmentsQuery = createAutoQuery({
            url: 'QueryShipmentsYOYTotals.json?Sum=TotalShipmentsMonthToDate,TotalShipmentsQuarterToDate,TotalShipmentsYearToDate,TotalShipmentsMonthToDateLastYear,TotalShipmentsQuarterToDateLastYear,TotalShipmentsYearToDateLastYear&GroupBy=' + groupBy + repFilter,
            autoLoad: true,
			take: 10000,
            onLoaded: function(args) {
                if (args.count > 0) {
                    args.results.forEach(function(res) {
                        $ctrl.monthShipments.total += res.sumTotalShipmentsMonthToDate;
                        $ctrl.quarterShipments.total += res.sumTotalShipmentsQuarterToDate;
                        $ctrl.ytdShipments.total += res.sumTotalShipmentsYearToDate;
                        $ctrl.monthShipmentsLY.total += res.sumTotalShipmentsMonthToDateLastYear;
                        $ctrl.quarterShipmentsLY.total += res.sumTotalShipmentsQuarterToDateLastYear;
                        $ctrl.ytdShipmentsLY.total += res.sumTotalShipmentsYearToDateLastYear;

						//console.info("BL*** ytdSales = " + $ctrl.ytdSales.total);
                    });

					var percent = Math.round(($ctrl.monthShipments.total / $ctrl.monthShipmentsLY.total) * 100);
					if (percent < 100) {
						$ctrl.monthShipments.percent = 100 - percent;
						$ctrl.monthShipments.trend = 'down';
					} else if (percent > 100) {
						$ctrl.monthShipments.percent = percent - 100;
						$ctrl.monthShipments.trend = 'up';
					} else {
						$ctrl.monthShipments.percent = 100;
						$ctrl.monthShipments.trend = 'neutral';
					}

					var percent = Math.round(($ctrl.quarterShipments.total / $ctrl.quarterShipmentsLY.total) * 100);
					if (percent < 100) {
						$ctrl.quarterShipments.percent = 100 - percent;
						$ctrl.quarterShipments.trend = 'down';
					} else if (percent > 100) {
						$ctrl.quarterShipments.percent = percent - 100;
						$ctrl.quarterShipments.trend = 'up';
					} else {
						$ctrl.quarterShipments.percent = 100;
						$ctrl.quarterShipments.trend = 'neutral';
					}

					var percent = Math.round(($ctrl.ytdShipments.total / $ctrl.ytdShipmentsLY.total) * 100);
					if (percent < 100) {
						$ctrl.ytdShipments.percent = 100 - percent;
						$ctrl.ytdShipments.trend = 'down';
					} else if (percent > 100) {
						$ctrl.ytdShipments.percent = percent - 100;
						$ctrl.ytdShipments.trend = 'up';
					} else {
						$ctrl.ytdShipments.percent = 100;
						$ctrl.ytdShipments.trend = 'neutral';
					}

					$ctrl.goalChartLabels = ["Month", "Quarter", "Year"];
                    $ctrl.goalChartSeries = ["Shipments","Goal"];

                    $ctrl.goalChartData = [];
					$ctrl.tableData = [];
                    var today = new Date();
                    $ctrl.loadGoalChartData = function(args) {
                        $ctrl.goalChartLabels = ["Month", "Quarter", "Year"];
                        $ctrl.goalChartSeries = ["Shipments","Goal", "Last Year"];
                        $ctrl.goalChartData = [];
                        var flags = [];

                        var goalSeriesData = [Math.round($ctrl.monthShipments.total),Math.round($ctrl.quarterShipments.total),Math.round($ctrl.ytdShipments.total)];
                        $ctrl.goalChartData.push(goalSeriesData);
						$ctrl.tableData.push({
							label: 'This Year',
							mtd: Math.round($ctrl.monthShipments.total),
							mtdpercent: $ctrl.monthShipments.percent,
							mtdtrend: $ctrl.monthShipments.trend,
							qtd: Math.round($ctrl.quarterShipments.total),
							qtdpercent: $ctrl.quarterShipments.percent,
							qtdtrend: $ctrl.quarterShipments.trend,
							ytd: Math.round($ctrl.ytdShipments.total),
							ytdpercent: $ctrl.ytdShipments.percent,
							ytdtrend: $ctrl.ytdShipments.trend,
						});

                        var qtrGoal = 0;
                        var qtr1Goal = 0;
                        var qtr2Goal = 0;
                        var qtr3Goal = 0;
                        var qtr4Goal = 0;
                        var monthGoal = 0;
                        var totalGoal = 0;
                        var thisMonth = moment().month() + 1;
                        args.results.forEach(function(r) {
                            var month = r.month; // moment(r.month).month();
                            if (month == 0 || month == 1 || month == 2) {
                                qtr1Goal += r.invoiceGoal;
                            } else if (month == 3 || month == 4 || month == 5) {
                                qtr2Goal += r.invoiceGoal;
                            } else if (month == 6 || month == 7 || month == 8) {
                                qtr3Goal += r.invoiceGoal;
                            } else if (month == 9 || month == 10 || month == 11) {
                                qtr4Goal += r.invoiceGoal;
                            }
                            if (month == thisMonth) {
                                monthGoal = r.invoiceGoal;
                            }
                            totalGoal += r.invoiceGoal;
                        });
                        if (moment().quarter() == 1) {
                            qtrGoal = Math.round(qtr1Goal);
                        } else if (moment().quarter() == 2) {
                            qtrGoal = Math.round(qtr2Goal);
                        } else if (moment().quarter() == 3) {
                            qtrGoal = Math.round(qtr3Goal);
                        } else if (moment().quarter() == 4) {
                            qtrGoal = Math.round(qtr4Goal);
                        }
                        var goalSeriesData = [Math.round(monthGoal),qtrGoal,Math.round(totalGoal)];
						$ctrl.goalChartData.push(goalSeriesData);

						var mtdGoalPercent = 0;
						var mtdGoalTrend = 0;
						var qtdGoalPercent = 0;
						var qtdGoalTrend = 0;
						var ytdGoalPercent = 0;
						var ytdGoalTrend = 0;

						var percent = Math.round(($ctrl.monthShipments.total / monthGoal) * 100);
						if (percent < 100) {
							mtdGoalPercent = 100 - percent;
							mtdGoalTrend = 'down';
						} else if (percent > 100) {
							mtdGoalPercent = percent - 100;
							mtdGoalTrend = 'up';
						} else {
							mtdGoalPercent = 100;
							mtdGoalTrend = 'neutral';
						}
						var percent = Math.round(($ctrl.quarterShipments.total / qtrGoal) * 100);
						if (percent < 100) {
							qtdGoalPercent = 100 - percent;
							qtdGoalTrend = 'down';
						} else if (percent > 100) {
							qtdGoalPercent = percent - 100;
							qtdGoalTrend = 'up';
						} else {
							qtdGoalPercent = 100;
							qtdGoalTrend = 'neutral';
						}
						var percent = Math.round(($ctrl.ytdShipments.total / totalGoal) * 100);
						if (percent < 100) {
							ytdGoalPercent = 100 - percent;
							ytdGoalTrend = 'down';
						} else if (percent > 100) {
							ytdGoalPercent = percent - 100;
							ytdGoalTrend = 'up';
						} else {
							ytdGoalPercent = 100;
							ytdGoalTrend = 'neutral';
						}
/*						$ctrl.tableData.push({
							label: 'Goal',
							mtd: Math.round(monthGoal),
							mtdpercent: mtdGoalPercent,
							mtdtrend: mtdGoalTrend,
							qtd: Math.round(qtrGoal),
							qtdpercent: qtdGoalPercent,
							qtdtrend: qtdGoalTrend,
							ytd: Math.round(totalGoal),
							ytdpercent: ytdGoalPercent,
							ytdtrend: ytdGoalTrend,
						});
*/

                        var goalSeriesDataLY = [Math.round($ctrl.monthShipmentsLY.total),Math.round($ctrl.quarterShipmentsLY.total),Math.round($ctrl.ytdShipmentsLY.total)];
                        $ctrl.goalChartData.push(goalSeriesDataLY);
						$ctrl.tableData.push({
							label: 'Last Year',
							mtd: Math.round($ctrl.monthShipmentsLY.total),
							qtd: Math.round($ctrl.quarterShipmentsLY.total),
							ytd: Math.round($ctrl.ytdShipmentsLY.total)
						});
                        $ctrl.chartLoaded = true;

                    }
                    $ctrl.shipmentsGoals = createAutoQuery({
                        url: 'QueryRepMonthlyGoals.json?' + repFilter,
						take: 10000,
                        autoLoad: true,
                        onLoaded: args => {$ctrl.loadGoalChartData(args);}
                    });
                }
            }
        });

    }
}

let SalesRepShipmentsGoalsLYChart = {
    bindings: {
		rep: '<',
        context: '@'
    },
    //require:{
    //    container: '^salesrepDashboard'
    //},
    controller: SalesRepShipmentsGoalsLYChartController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default SalesRepShipmentsGoalsLYChart